import { FC } from 'react'
import { AccordionContent } from '@yuno/sdk-web-core/dist/ui/primitives/accordion'
import { useBreakpoint } from '@yuno/sdk-web-core/dist/hooks/use-breakpoint'
import {
  AccordionHeadingPurchase,
  Heading,
  Instructions,
  LanguageSelectorTop,
  LeftPanelFooter,
  MerchantLogo,
  OrderContainer,
  OrderDetailsList,
  OrderHeader,
  OrderMobileAccordion,
  OrderScrollArea,
  TitleBlock,
} from './order.styled'
import {
  OrderDetailContent,
  OrderDetailPurchase,
  OrderTotal,
} from './order-components'
import { useOrder } from './use-order'
import { PURCHASE_DETAILS_ID, PURCHASE_ID } from './order.constants'
import { useTranslation } from 'react-i18next'
import { useDescription } from '../../hooks'
import { queryClient } from '../../state'
import { CheckoutInfo } from '../../types'
import { LanguageSelector } from '../language-selector'
import { getMerchantLogo } from '../payment-checkout/payment-methods/payment-methods.utils'

export const Order: FC = () => {
  const {
    onChange,
    order,
    airline,
    totalDue,
    currency,
  } = useOrder()
  const { isDesktop } = useBreakpoint()
  const { t } = useTranslation()
  const { description } = useDescription()
  const checkoutInfo = queryClient.getQueryData<CheckoutInfo>(['checkout-info'])
  const merchantImage = getMerchantLogo(checkoutInfo?.payment_link?.style ?? null)
    || checkoutInfo?.payment_link?.merchant_image

  const hasDetails = Boolean(order?.items?.length || airline?.legs?.length)

  const detailsContent = (
    <OrderDetailsList>
      {order?.items?.map((item, index) => (
        <OrderDetailContent key={index} {...item} currency={currency} />
      ))}
      {airline?.legs && <OrderDetailPurchase items={airline.legs} />}
    </OrderDetailsList>
  )

  return (
    <OrderContainer>
      <LanguageSelectorTop>
        <LanguageSelector />
      </LanguageSelectorTop>
      <OrderHeader>
        {merchantImage && <MerchantLogo src={merchantImage} alt="merchant logo" />}
        <TitleBlock>
          <Heading>{t('Review your order')}</Heading>
          {description && <Instructions>{description}</Instructions>}
        </TitleBlock>
      </OrderHeader>
      <OrderTotal totalDue={totalDue} currency={currency} />
      {hasDetails && (
        !isDesktop ? (
          <OrderMobileAccordion onChange={onChange}>
            <AccordionHeadingPurchase
              id={PURCHASE_ID}
              ariaControls={PURCHASE_DETAILS_ID}
              open={false}
            >
              {t('Purchase details')}
            </AccordionHeadingPurchase>
            <AccordionContent id={PURCHASE_DETAILS_ID} ariaLabelledBy={PURCHASE_ID}>
              {detailsContent}
            </AccordionContent>
          </OrderMobileAccordion>
        ) : (
          <OrderScrollArea>
            {detailsContent}
          </OrderScrollArea>
        )
      )}
      <LeftPanelFooter>
        <LanguageSelector />
      </LeftPanelFooter>
    </OrderContainer>
  )
}
